<template>
  <MallBottomSheet :dim="dim" @close="$emit('close')">
    <div class="mall-notice-sheet">
      <img class="mall-notice-sheet__icon" src="@/assets/mall/icn_warning_circle_color.svg" alt="" />
      <div class="mall-notice-sheet__text">
        <span class="typo-lg-semi">{{ title }}</span>
        <span class="typo-body-m-medium">
          <span v-for="line in messageLines" :key="line" class="mall-notice-sheet__line">{{ line }}</span>
        </span>
      </div>
    </div>

    <template slot="buttons">
      <MallButton v-if="cancelLabel" :label="cancelLabel" :type="'secondary'" @click="$emit('cancel')" />
      <MallButton :label="confirmLabel" :type="'primary'" @click="$emit('confirm')" />
    </template>
  </MallBottomSheet>
</template>

<script>
import MallButton from '@/components/new/atoms/MallButton.vue'
import MallBottomSheet from '@/components/new/molecules/MallBottomSheet.vue'

export default {
  name: 'MallNoticeSheet',
  components: {
    MallButton,
    MallBottomSheet,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    // 줄 단위 안내 문구
    messageLines: {
      type: Array,
      required: true,
    },
    confirmLabel: {
      type: String,
      default: '확인했어요',
    },
    // 없으면 버튼 하나만 노출
    cancelLabel: {
      type: String,
      default: '',
    },
    // MallBottomSheet dim ('light' | 'normal')
    dim: {
      type: String,
      default: 'light',
    },
  },
}
</script>

<style scoped>
.mall-notice-sheet {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mall-notice-sheet__icon {
  display: block;
  align-self: flex-start;
}

.mall-notice-sheet__text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mall-notice-sheet__line {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallNoticeSheet.vue